<article [class.set--active]="active" class="workshop-card" [class.has--skew-bg]="item.image.url">
  <fstr-link [button]="{ url: item.link, text: '' }" [cssClasses]="'block-link'">
    <figure class="mb-3 mb-md-6 workshop-card__figure" *ngIf="item.image.url">
      <fstr-image
        *ngIf="item.image"
        [alt]="item.image.alt || item.title"
        [image]="item.image"
        [imageSizes]="[500, 900, 1200]"
        [width]="520"
        [height]="333"
      ></fstr-image>
    </figure>
    <main class="workshop-card__main">
      <h2 class="workshop-card__title mb-3 mb-4">{{ item.title }}</h2>
      <p class="workshop-card__text fw-light mb-0">{{ item.subtitle }}</p>
    </main>
  </fstr-link>
</article>
